// import * as PIXI from 'pixi.js-legacy'

import Shape from './index'

export default class Group extends Shape {
  constructor(props = {}, children) {
    super(makeGroupProps(props))
    if (children && children.length) {
      children.forEach((c) => this.addChild(c))
    }
  }

  find = (q) => {
    const { ctx } = this
    const type = q.substr(0, 1) === '#' ? 'id' : 'name'
    const val = q.substr(1)
    return (ctx.children.filter((c) => c.shape && c.shape[type] === val)[0] || {}).shape
  }

  addChild = (c) => {
    this.ctx.addChild(c.ctx || c)
  }

  removeChildren = () => {
    this.ctx.removeChildren()
  }

  removeChild = (c) => {
    this.ctx.removeChild(c.ctx || c)
  }

  addChildAt = (c, i) => {
    this.ctx.addChildAt(c.ctx || c, i)
  }
}

function makeGroupProps(props) {
  props.isGroup = true
  return props
}
